import React, { useState } from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import {
  Popover,
  CardHeader,
  CardActions,
  Divider,
  Button,
  TextField
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    width: 231,
    maxWidth: '100%'
  },
  inputPadding: {
    padding: theme.spacing(0, 1),
    paddingBottom: theme.spacing(1)
  },
  actions: {
    justifyContent: 'center',
    padding: 0
  },
  button: {
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    padding: theme.spacing(2)
  },
  paper: {
    overflowX: 'unset',
    overflowY: 'unset',
    marginTop: 10,
    '&::before': {
      content: '""',
      position: 'absolute',
      top: -20,
      right: '50%',
      left: '50%',
      transform: 'translate(-50%,0)',
      borderBottom: '10px solid white',
      borderRight: '10px solid transparent',
      borderLeft: '10px solid transparent',
      borderTop: '10px solid transparent',
      zIndex: 10,
    },
  }
}));

const NotificationsPopover = props => {
  const { title, anchorEl, arrow, onSubmit, ...rest } = props;

  const classes = useStyles();

  const [name, setName] = useState('');

  const handleClose = () => {
    rest.onClose();
    setName('');
  }

  return (
    <Popover
      {...rest}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left'
      }}
      classes={{ paper: clsx({ [classes.paper]: arrow }) }}
    >
      <div className={classes.root}>
        <CardHeader title={title} />
        <div className={classes.inputPadding}>
          <TextField
            autoFocus
            fullWidth
            label="Name"
            margin="dense"
            name="name"
            onChange={({ target }) => setName(target.value)}
            value={name || ''}
            variant="outlined"
          />
        </div>
        <Divider />
        <CardActions className={classes.actions}>
          <Button
            className={classes.button}
            disabled={!name.length}
            fullWidth
            onClick={() => onSubmit(name, handleClose)}
            size="small"
          >
            Apply
          </Button>
        </CardActions>
      </div>
    </Popover>
  );
};

NotificationsPopover.propTypes = {
  anchorEl: PropTypes.any,
  arrow: PropTypes.bool.isRequired,
  className: PropTypes.string,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func,
  open: PropTypes.bool.isRequired,
  title: PropTypes.string
};

NotificationsPopover.defaultProps = {
  arrow: false
};

export default NotificationsPopover;
